import { type PropsWithChildren, useEffect } from "react";
import { useShowFlash } from "@sprout/flash.tsx";
import useTranslation from "@hooks/use_translation.ts";

// When we make requests using Inertia's router instead of Axios, Inertia expects
// an Inertia response. There are some cases where we expect the server to send
// responses that Inertia will be unable to handle. This error boundary catches
// those events and cancels them, showing a toast message instead.
export const InertiaErrorBoundary = ({ children }: PropsWithChildren) => {
  const showFlash = useShowFlash();
  const { t } = useTranslation("misc");

  useEffect(() => {
    const handleError = (event: CustomEvent) => {
      // This is the error code we get back from Rack::Attack when throttling a user
      const isThrottleResponse = event.detail?.response?.status === 429;

      if (!isThrottleResponse) {
        return;
      }

      event.preventDefault();

      showFlash(t("429.flash"), "error");
    };

    document.addEventListener("inertia:invalid", handleError);

    return () => {
      document.removeEventListener("inertia:invalid", handleError);
    };
  });

  return <>{children}</>;
};
